import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/I18nContext';
import './Footer.css';

const Footer = () => {
  const { t } = useT();
  const currentYear = new Date().getFullYear();
  const extensionDownloadUrl = '/downloads/flashsync-chrome-extension.zip';
  const repositoryUrl = 'https://gitee.com/kobeyoung81/flashsync';

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-shell">
          <div className="footer-brand">
            <span className="footer-badge">{t('footer.tagline')}</span>
            <h2>{t('footer.brand')}</h2>
            <p>{t('footer.desc')}</p>
          </div>

          <div className="footer-grid">
            <div className="footer-section">
              <h3>{t('footer.product')}</h3>
              <ul>
                <li><Link to="/">{t('footer.overview')}</Link></li>
                <li><Link to="/dashboard">{t('footer.dashboard')}</Link></li>
                <li><Link to="/settings">{t('footer.settings')}</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>{t('footer.access')}</h3>
              <ul>
                <li><Link to="/login">{t('footer.login')}</Link></li>
                <li><Link to="/register">{t('footer.createAccount')}</Link></li>
                <li><a href={extensionDownloadUrl} download>{t('footer.downloadExt')}</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>{t('footer.resources')}</h3>
              <ul>
                <li><a href={repositoryUrl} target="_blank" rel="noopener noreferrer">{t('footer.sourceCode')}</a></li>
                <li><a href={repositoryUrl} target="_blank" rel="noopener noreferrer">{t('footer.deployDocs')}</a></li>
                <li><a href={repositoryUrl} target="_blank" rel="noopener noreferrer">{t('footer.projectUpdates')}</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {t('footer.brand')}. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
